const ButtonConditional = ({ width, height = "8" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="12.9737"
        y="0.810547"
        width="6.5887"
        height="6.5887"
        rx="0.941243"
        fill="#40E5A0"
      />
      <path
        d="M13.4444 4.10547H1.20825"
        stroke="#40E5A0"
        strokeWidth="1.41186"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ButtonConditional;
